import { useTranslation } from '../i18n';
import React from 'react';
import { Tag } from 'antd';

/**
 * Single source of truth for LLM account status -> color/label mapping.
 *
 * Previously this map was duplicated inside admin/pages/llm/Users.jsx (twice:
 * the table column and the detail modal). Import this helper instead of writing
 * a local copy so all surfaces stay in sync.
 */
export const LLM_STATUS_META = {
  active: { color: 'green', label: '正常' },
  suspended: { color: 'orange', label: '暂停' },
  deleted: { color: 'red', label: '已删除' },
};

/**
 * Reusable status Tag for an LLM account.
 * @param {{ status?: string }} props
 */
const LlmStatusTag = ({ status }) => {
  const { t } = useTranslation();
  const meta = LLM_STATUS_META[status] || { color: 'default', label: status || t('Unknown') };
  return <Tag color={meta.color}>{t(meta.label)}</Tag>;
};

export default LlmStatusTag;
